import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-medium text-white text-wrap" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "w-48 truncate font-mono text-xs text-zinc-400" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-sm font-medium text-white" }
const _hoisted_9 = { class: "flex flex-wrap gap-2" }
const _hoisted_10 = { class: "flex justify-end gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = { class: "text-white font-bold text-lg" }
const _hoisted_16 = { class: "flex flex-col items-end gap-2" }
const _hoisted_17 = { class: "flex items-center gap-1" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex items-center gap-2 bg-white/5 p-2 rounded justify-between" }
const _hoisted_21 = { class: "font-mono text-xs text-zinc-400 truncate max-w-[250px]" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex items-center justify-between pt-2" }
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "text-white text-sm" }
const _hoisted_26 = { class: "flex flex-wrap gap-1" }
const _hoisted_27 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_28 = { class: "grid grid-cols-2 gap-6 py-4" }
const _hoisted_29 = { class: "grid gap-2 col-span-full" }
const _hoisted_30 = { class: "grid gap-2 col-span-full" }
const _hoisted_31 = { class: "grid gap-2 col-span-full" }
const _hoisted_32 = {
  key: 0,
  class: "grid gap-2 col-span-full"
}
const _hoisted_33 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_34 = { class: "grid gap-2 col-span-full" }
const _hoisted_35 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_36 = {
  key: 2,
  class: "flex items-center gap-2 col-span-full text-white text-sm"
}
const _hoisted_37 = { class: "grid gap-4 py-4" }
const _hoisted_38 = { class: "grid gap-2" }
const _hoisted_39 = {
  key: 0,
  class: "flex items-center gap-2 text-blue-400 text-xs"
}
const _hoisted_40 = { class: "flex items-center gap-2 text-amber-500 text-xs" }

import { ref, computed, onMounted, watch } from 'vue'
import {
  ArrowsUpDownIcon,
  UsersIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/vue/24/outline'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogScrollContent,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Badge } from '@/components/ui/badge'
import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { CreateGroupDTO, GetAllGroupsParams, UpdateGroupDTO, useGroup } from '@/composables/useGroup'
import { Group } from '@/interfaces/Group'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { GroupCategoryEnum, GroupCategoryLabels } from '@/enums/groups/GroupCategoryEnum'
import { usePaymentPlan } from '@/composables/usePaymentPlan'
import { PaymentPlan } from '@/interfaces/PaymentPlan'
import { ArrowRightLeft, CircleHelp, ClipboardIcon, InfoIcon, Loader2, PlusIcon } from 'lucide-vue-next'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import { useToast } from '@/components/ui/toast'
import { TagsInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText } from '@/components/ui/tags-input'
import { ComboboxAnchor, ComboboxContent, ComboboxInput, ComboboxPortal, ComboboxRoot } from 'radix-vue'
import TagsInputInput from '@/components/ui/tags-input/TagsInputInput.vue'
import { CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command'
import { AcceptableInputValue } from 'radix-vue/dist/TagsInput/TagsInputRoot'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import { useTime } from '@/composables/useTime'
import { TimeUnitEnum, TimeUnitLabels } from '@/enums/TimeUnitEnum'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Switch } from '@/components/ui/switch'
import { RouterLink } from 'vue-router'
import { MessageRecipientTypeEnum } from '@/enums/messages/MessageRecipientTypeEnum'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageGroupsView',
  setup(__props) {

const { toast } = useToast()
const { create, update, getAll, destroy, migrateLeads } = useGroup()
const { getAll: getAllPaymentPlans } = usePaymentPlan()
const paymentPlans = ref<IPagination<PaymentPlan>>()
// Table Configuration
const tableHeaders = [
  { key: 'name', label: 'Nome', sortable: false },
  { key: 'link', label: 'Link', sortable: false },
  { key: 'category', label: 'Categoria', sortable: false },
  { key: 'plans', label: 'Planos de pagamento', sortable: false },
  { key: 'actions', label: '', class: 'w-32' },
]
const isSaving = ref(false)
const perPage = ref('10')

// Filters
const filteredPaymentPlans = computed(() => paymentPlans.value?.data.filter(i => !groupForm.value.paymentPlanIds?.includes(String(i.id))))
const searchPaymentPlan = ref('')
const isPaymentPlanComboboxOpen = ref(false)
// Groups data (empty for demo)
const groups = ref<IPagination<Group>>()
const paymentPlanNames = ref<string[]>([])
// Modal and Form
const isGroupModalOpen = ref(false)
const editingGroup = ref<number | null>(null)
const groupForm = ref<Partial<CreateGroupDTO>>({
  name: '',
  groupId: undefined,
  paymentPlanIds: []
})
const timeUnit = ref<TimeUnitEnum>(TimeUnitEnum.SECONDS)
const { convertToSeconds, convertFromSeconds, convertIntervalToSeconds, convertToInterval } = useTime()
const deletingGroup = ref<number>()
const isDeleteGroupDialogOpen = ref(false)
const isDeletingGroup = ref(false)

// Migration
const isMigrateModalOpen = ref(false)
const isMigrating = ref(false)
const migratingFromGroup = ref<Group | null>(null)
const migrateToGroupId = ref<string>('')
const availableTargetGroups = computed(() => groups.value?.data || [])

// Actions
const openNewGroupModal = () => {
  editingGroup.value = null
  groupForm.value = {
    name: '',
    paymentPlanIds: []
  }
  isGroupModalOpen.value = true
}

const closeGroupModal = () => {
  isGroupModalOpen.value = false
}

const editGroup = (group: Group) => {
  editingGroup.value = group.id
  const delayInSeconds = group.newMembersAcceptanceDelay ? convertIntervalToSeconds(group.newMembersAcceptanceDelay) : 0
  const { value: newMembersAcceptanceDelay, unit } = convertFromSeconds(delayInSeconds);

  timeUnit.value = unit;
  groupForm.value = {
    name: group.name,
    groupId: group.groupId,
    category: group.category,
    newMembersAcceptanceDelay,
    welcomeMessage: group.welcomeMessage,
    paymentPlanIds: ((group.paymentPlans?.map(plan => String(plan.id)) ?? []) as unknown as AcceptableInputValue[]),
    newMembersAutomaticApproval: group.newMembersAutomaticApproval
  }
  paymentPlanNames.value = group.paymentPlans?.map(plan => plan.name) ?? []
  isGroupModalOpen.value = true
}

const deleteGroup = (group: any) => {
  isDeleteGroupDialogOpen.value = true
  deletingGroup.value = group.id
}

const openMigrateModal = (group: Group) => {
  migratingFromGroup.value = group
  migrateToGroupId.value = ''
  isMigrateModalOpen.value = true
}

const confirmMigration = async () => {
  if (!migratingFromGroup.value || !migrateToGroupId.value) return

  isMigrating.value = true
  try {
    await migrateLeads(migratingFromGroup.value.id, Number(migrateToGroupId.value))
    
    toast({
      title: 'Migração iniciada',
      description: 'O processo de migração foi enfileirado e será processado em breve.',
      class: 'bg-green-500 text-white',
      duration: 3000
    })
    
    isMigrateModalOpen.value = false
  } catch (error) {
    toast({
      title: 'Erro ao migrar leads',
      description: 'Ocorreu um erro ao tentar iniciar a migração.',
      variant: 'destructive',
      duration: 3000
    })
  } finally {
    isMigrating.value = false
  }
}

const sortBy = (key: string) => {
  // Implement sorting logic
}

const copyGroupLink = async (group: Group) => {
  const link = `https://tinyurl.com/3avpxfmx/${group.uuid}`
  await navigator.clipboard.writeText(link)
  toast({
    title: 'Link copiado para a área de transferência',
    class: 'bg-green-500 text-white',
    duration: 1500
  })
}

const save = async () => {
  isSaving.value = true

  try {
    let payload = { ...groupForm.value }
    
    if (payload.newMembersAcceptanceDelay && timeUnit.value) {
      payload.newMembersAcceptanceDelay = convertToSeconds(payload.newMembersAcceptanceDelay, timeUnit.value)
    }

    if (!editingGroup.value) {
      const group = await create(payload as CreateGroupDTO)
      toast({
        title: 'Grupo criado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      groups.value?.data.push(group)
    } else {
      await update(editingGroup.value, payload as UpdateGroupDTO)
      toast({
        title: 'Grupo editado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })

      const _paymentPlans = paymentPlans.value?.data.filter(plan => payload.paymentPlanIds?.includes(String(plan.id))) ?? []
      const index = groups.value!.data.findIndex(group => group.id == editingGroup.value)
      
      if (index !== -1 && index !== null) {
        groups.value!.data[index] = { 
          ...groups.value!.data[index], 
          ...groupForm.value,
          paymentPlans: _paymentPlans,
          newMembersAcceptanceDelay: payload.newMembersAcceptanceDelay
            ? convertToInterval(payload.newMembersAcceptanceDelay, TimeUnitEnum.SECONDS)
            : null
        } as Group
      }
    }

    isGroupModalOpen.value = false
  } finally {
    isSaving.value = false
  }
}

function reloadAndGetAll(params: GetAllGroupsParams) {
  groups.value = undefined
  getAll(params)
    .then(data => groups.value = data)
}

watch(() => perPage.value, () => {
  reloadAndGetAll({ perPage: perPage.value })
})

watch(() => isGroupModalOpen.value, () => {
  if (!paymentPlans.value) {
    getAllPaymentPlans({ perPage: '50' })
      .then((data) => paymentPlans.value = data)
  }
})

onMounted(() => {
  getAll()
    .then((data) => groups.value = data)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(PageTitle, null, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode(" Gerencie grupos e canais ")
            ])),
            _: 1
          }),
          _createVNode(PageDescription, null, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode(" Expanda seu plano de assinatura com mais grupos ou canais. Configure planos de pagamento e otimize a experiência dos seus assinantes. ")
            ])),
            _: 1
          })
        ]),
        _createVNode(RegisterButton, { onClick: openNewGroupModal }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("Cadastrar grupo")
          ])),
          _: 1
        })
      ]),
      _createVNode(TableContainer, null, {
        default: _withCtx(() => [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mb-6 flex items-center justify-between" }, [
            _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Grupos e canais registrados"),
            _createElementVNode("div", { class: "flex items-center gap-4" })
          ], -1)),
          _createVNode(Table, { class: "hidden md:block" }, {
            default: _withCtx(() => [
              _createVNode(TableHeader, null, {
                default: _withCtx(() => [
                  _createVNode(TableRow, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                        return _createVNode(TableHead, {
                          key: header.key,
                          class: _normalizeClass(header.class)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(header.label) + " ", 1),
                              (header.sortable)
                                ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                    key: 0,
                                    class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                    onClick: ($event: any) => (sortBy(header.key))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(TableBody, null, {
                default: _withCtx(() => [
                  (groups.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (groups.value.data.length === 0)
                          ? (_openBlock(), _createBlock(TableFallback, {
                              key: 0,
                              colspan: tableHeaders.length,
                              icon: _unref(UsersIcon),
                              title: "Nenhum grupo ou canal encontrado",
                              description: `Clique em 'Cadastrar grupo' para começar`
                            }, null, 8, ["colspan", "icon"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value.data, (group) => {
                          return (_openBlock(), _createBlock(TableRow, {
                            key: group.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(group.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(`https://tinyurl.com/3avpxfmx/${group.uuid}`), 1),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (copyGroupLink(group)),
                                      class: "rounded-lg bg-white/5 p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white group-hover:opacity-100"
                                    }, [
                                      _createVNode(_unref(ClipboardIcon), { class: "h-4 w-4 text-white" })
                                    ], 8, _hoisted_7)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(GroupCategoryLabels)[group.category]), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.paymentPlans, (plan) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: plan.id,
                                        variant: "default"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(plan.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      onClick: ($event: any) => (editGroup(group))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "hover:text-primary",
                                      onClick: ($event: any) => (openMigrateModal(group)),
                                      title: "Migrar leads"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ArrowRightLeft), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "hover:text-red-400",
                                      onClick: ($event: any) => (deleteGroup(group))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock(TableRowSkeleton, {
                        key: 1,
                        columns: tableHeaders.length
                      }, null, 8, ["columns"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (groups.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (groups.value.data.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(groups.value.data, (group) => {
                      return (_openBlock(), _createBlock(MobileCard, {
                        key: group.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Grupo", -1)),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(group.name), 1)
                              ])
                            ])
                          ])
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (editGroup(group)),
                                class: "text-zinc-400 hover:text-white p-1"
                              }, [
                                _createVNode(_unref(PencilIcon), { class: "size-5" })
                              ], 8, _hoisted_18),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (deleteGroup(group)),
                                class: "text-zinc-400 hover:text-red-400 p-1"
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "size-5" })
                              ], 8, _hoisted_19)
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          _createVNode(MobileDataLabel, { label: "Link do grupo" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, _toDisplayString(`https://tinyurl.com/3avpxfmx/${group.uuid}`), 1),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (copyGroupLink(group)),
                                  class: "rounded-lg p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white"
                                }, [
                                  _createVNode(_unref(ClipboardIcon), { class: "size-4 text-white" })
                                ], 8, _hoisted_22)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Categoria", -1)),
                              _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(GroupCategoryLabels)[group.category]), 1)
                            ])
                          ]),
                          (group.paymentPlans?.length)
                            ? (_openBlock(), _createBlock(MobileDataLabel, {
                                key: 0,
                                label: "Planos de pagamento"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_26, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.paymentPlans, (plan) => {
                                      return (_openBlock(), _createBlock(_unref(Badge), {
                                        key: plan.id,
                                        variant: "default",
                                        class: "text-xs"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(plan.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_unref(UsersIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                      _cache[23] || (_cache[23] = _createTextVNode(" Nenhum grupo ou canal encontrado "))
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createVNode(Pagination, {
            "onUpdate:page": _cache[0] || (_cache[0] = (page) => reloadAndGetAll({ page })),
            "per-page": perPage.value,
            "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event)),
            data: groups.value?.pagination
          }, null, 8, ["per-page", "data"])
        ]),
        _: 1
      })
    ]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeleteGroupDialogOpen.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isDeleteGroupDialogOpen).value = $event)),
      loading: isDeletingGroup.value,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => {isDeletingGroup.value = true; _unref(destroy)(deletingGroup.value!).then(() => {
    _unref(toast)({
      title: 'Grupo excluído com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })
    isDeletingGroup.value = false
    isDeleteGroupDialogOpen.value = false
    const index = groups.value?.data.findIndex(group => group.id == deletingGroup.value)
    if (index !== -1) groups.value?.data.splice(index!, 1)
  })})
    }, null, 8, ["open", "loading"]),
    _createVNode(_unref(Dialog), {
      open: isGroupModalOpen.value,
      "onUpdate:open": _cache[14] || (_cache[14] = ($event: any) => ((isGroupModalOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-2xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editingGroup.value ? 'Editar grupo ou canal' : 'Novo grupo ou canal'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode(" Configure as informações do grupo ou canal e selecione os planos de pagamento. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode("Nome do grupo/canal "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: groupForm.value.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((groupForm.value.name) = $event)),
                  placeholder: "Ex: VIP"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_unref(Label), { class: "flex items-center gap-2" }, {
                  default: _withCtx(() => [
                    _cache[28] || (_cache[28] = _createTextVNode(" ID do grupo/canal ")),
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-red-500" }, "*", -1)),
                    _createVNode(_unref(TooltipProvider), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(TooltipContent), {
                              side: "top",
                              "side-offset": 5
                            }, {
                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                _createTextVNode(" O ID do grupo só é válido para "),
                                _createElementVNode("span", { class: "text-emerald-500" }, "super grupos", -1),
                                _createTextVNode(" e "),
                                _createElementVNode("span", { class: "text-emerald-500" }, "canais", -1),
                                _createTextVNode(". "),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" Para converter um "),
                                _createElementVNode("span", { class: "text-red-500" }, "grupo comum", -1),
                                _createTextVNode(" para "),
                                _createElementVNode("span", { class: "text-emerald-500" }, "super grupo", -1),
                                _createTextVNode(" basta "),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" adicionar seu bot como admin com todas as permissões "),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" ao grupo e em seguida obter o novo ID. ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: groupForm.value.groupId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((groupForm.value.groupId) = $event)),
                  type: "string",
                  placeholder: "Ex: 1234"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("Categoria "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Select), {
                  modelValue: groupForm.value.category,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((groupForm.value.category) = $event)),
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectTrigger), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectValue), { placeholder: "Selecione a categoria" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(SelectContent), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GroupCategoryEnum), (category) => {
                          return (_openBlock(), _createBlock(_unref(SelectItem), {
                            key: category,
                            value: category
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(GroupCategoryLabels)[category]), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (groupForm.value.category === _unref(GroupCategoryEnum).PAID)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode("Plano")
                      ])),
                      _: 1
                    }),
                    (filteredPaymentPlans.value)
                      ? (_openBlock(), _createBlock(_unref(TagsInput), {
                          key: 0,
                          class: "px-0 gap-0 w-full",
                          "model-value": paymentPlanNames.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlanNames.value, (name, index) => {
                                return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                  key: index,
                                  value: name
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(TagsInputItemText)),
                                    _createVNode(_unref(TagsInputItemDelete), {
                                      onClick: ($event: any) => {groupForm.value.paymentPlanIds?.splice(index, 1); paymentPlanNames.value.splice(index, 1)}
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _createVNode(_unref(ComboboxRoot), {
                              modelValue: paymentPlanNames.value,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((paymentPlanNames).value = $event)),
                              open: isPaymentPlanComboboxOpen.value,
                              "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((isPaymentPlanComboboxOpen).value = $event)),
                              "search-term": searchPaymentPlan.value,
                              "onUpdate:searchTerm": _cache[11] || (_cache[11] = ($event: any) => ((searchPaymentPlan).value = $event)),
                              class: "w-full"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ComboboxInput), {
                                      placeholder: "Plano premium...",
                                      "as-child": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(TagsInputInput, {
                                          onFocus: _cache[7] || (_cache[7] = ($event: any) => (isPaymentPlanComboboxOpen.value = true)),
                                          class: _normalizeClass(["w-full px-3", (groupForm.value.paymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                          onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                        }, null, 8, ["class"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ComboboxPortal), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ComboboxContent), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(CommandList), {
                                          position: "popper",
                                          class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(CommandEmpty), null, {
                                              default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                _createTextVNode("Nenhum plano encontrado")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_unref(CommandGroup), null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPaymentPlans.value, (paymentPlan) => {
                                                  return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                    key: paymentPlan.id,
                                                    value: String(paymentPlan.name),
                                                    onSelect: _withModifiers((ev) => {
                          if (typeof ev.detail.value === 'string') {
                            searchPaymentPlan.value = ''
                            const paymentPlan = filteredPaymentPlans.value?.find(plan => plan.name == ev.detail.value)
                            groupForm.value.paymentPlanIds?.push(String(paymentPlan!.id))
                            paymentPlanNames.value.push(paymentPlan!.name)
                          }
        
                          if (filteredPaymentPlans.value?.length === 0) {
                            isPaymentPlanComboboxOpen.value = false
                          }
                        }, ["prevent"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(paymentPlan.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value", "onSelect"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "open", "search-term"])
                          ]),
                          _: 1
                        }, 8, ["model-value"]))
                      : _createCommentVNode("", true),
                    _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-xs text-gray-400" }, "Você pode selecionar mais de 1 plano", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_unref(Label), { class: "flex items-center gap-2" }, {
                  default: _withCtx(() => [
                    _cache[35] || (_cache[35] = _createTextVNode(" Mensagem de boas vindas ")),
                    _createVNode(_unref(TooltipProvider), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Tooltip), { "delay-duration": 100 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(TooltipTrigger), { "as-child": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CircleHelp), { class: "size-5 text-primary" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(TooltipContent), {
                              side: "top",
                              "side-offset": 5
                            }, {
                              default: _withCtx(() => _cache[34] || (_cache[34] = [
                                _createElementVNode("span", {
                                  class: "text-primary",
                                  innerHTML: '{{nome}}'
                                }, null, -1),
                                _createTextVNode(": Nome do novo membro"),
                                _createElementVNode("br", null, null, -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Textarea), {
                  modelValue: groupForm.value.welcomeMessage,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((groupForm.value.welcomeMessage) = $event)),
                  placeholder: "Ex: Bem-vindo ao grupo"
                }, null, 8, ["modelValue"])
              ]),
              (groupForm.value.category === _unref(GroupCategoryEnum).FREE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_unref(Switch), {
                      checked: groupForm.value.newMembersAutomaticApproval,
                      "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((groupForm.value.newMembersAutomaticApproval) = $event))
                    }, null, 8, ["checked"]),
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("Aprovação automática")
                      ])),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (groupForm.value.category === _unref(GroupCategoryEnum).FREE && groupForm.value.newMembersAutomaticApproval)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createVNode(_unref(InfoIcon)),
                    _cache[37] || (_cache[37] = _createTextVNode(" É possível cadastrar uma mensagem que será enviada no privado do lead após a aprovação na aba de disparo de mensagens "))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "text-white",
                  variant: "ghost",
                  onClick: closeGroupModal
                }, {
                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isSaving.value || !groupForm.value.name || !groupForm.value.groupId || !groupForm.value.category || (groupForm.value.category === _unref(GroupCategoryEnum).PAID && !groupForm.value.paymentPlanIds?.length),
                  onClick: save
                }, {
                  default: _withCtx(() => [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(editingGroup.value ? 'Salvar alterações' : 'Cadastrar grupo'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(Dialog), {
      open: isMigrateModalOpen.value,
      "onUpdate:open": _cache[17] || (_cache[17] = ($event: any) => ((isMigrateModalOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "sm:max-w-md" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode("Migrar Leads")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => [
                    _cache[40] || (_cache[40] = _createTextVNode(" Selecione o grupo de destino para migrar todos os leads de ")),
                    _createElementVNode("strong", null, _toDisplayString(migratingFromGroup.value?.name), 1),
                    _cache[41] || (_cache[41] = _createTextVNode(". "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                    _createTextVNode("Grupo de destino")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Select), {
                  modelValue: migrateToGroupId.value,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((migrateToGroupId).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectTrigger), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectValue), { placeholder: "Selecione o grupo" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(SelectContent), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTargetGroups.value, (group) => {
                          return (_openBlock(), _createBlock(_unref(SelectItem), {
                            key: group.id,
                            value: String(group.id)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(group.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (migrateToGroupId.value === String(migratingFromGroup.value?.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_unref(InfoIcon), { class: "size-4" }),
                    _cache[43] || (_cache[43] = _createTextVNode(" Você está migrando para o mesmo registro de grupo. Isso é útil caso você tenha alterado o ID do grupo nas configurações e queira reenviar o link para os assinantes. "))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_unref(InfoIcon), { class: "size-4" }),
                _cache[44] || (_cache[44] = _createTextVNode(" Esta ação migrará todos os assinantes do grupo atual para o selecionado. "))
              ])
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "text-white",
                  variant: "ghost",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (isMigrateModalOpen.value = false))
                }, {
                  default: _withCtx(() => _cache[45] || (_cache[45] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: !migrateToGroupId.value || isMigrating.value,
                  onClick: confirmMigration
                }, {
                  default: _withCtx(() => [
                    (isMigrating.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin mr-2"
                        }))
                      : _createCommentVNode("", true),
                    _cache[46] || (_cache[46] = _createTextVNode(" Confirmar migração "))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})